import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Input } from "antd";
import { ESupportTicketQuestionType } from "@devowl-wp/api-real-commerce";
import { __ } from "../../utils/i18n.js";
const SupportFormMessageField = ()=>{
    return /*#__PURE__*/ _jsx(Form.Item, {
        shouldUpdate: (prevValues, nextValues)=>prevValues.questionType !== nextValues.questionType || prevValues.product !== nextValues.product || prevValues.languageOfSupport !== nextValues.languageOfSupport,
        noStyle: true,
        children: (param)=>{
            let { getFieldValue } = param;
            // Reload knowledge base articles when changing subject
            const questionType = getFieldValue("questionType");
            const isCustomOfferRequest = questionType === ESupportTicketQuestionType.RequestCustomOffer;
            return /*#__PURE__*/ _jsx(Form.Item, {
                name: "message",
                label: isCustomOfferRequest ? __("Additional requests") : __("Message"),
                rules: [
                    {
                        required: !isCustomOfferRequest,
                        message: __("Please insert your message!")
                    }
                ],
                required: !isCustomOfferRequest,
                children: /*#__PURE__*/ _jsx(Input.TextArea, {
                    autoSize: {
                        minRows: 2
                    }
                })
            });
        }
    });
};
export { SupportFormMessageField };
